import imageCompression from 'browser-image-compression';

export const compressImage = async (file) => {
  // Compress any image larger than 100KB
  if (file.size < 100 * 1024) return file;

  const options = {
    maxSizeMB: 1,             // Target ~1MB max size
    maxWidthOrHeight: 1024,   // Resize if large
    useWebWorker: true,
  };

  try {
    const compressedFile = await imageCompression(file, options);

    // ✅ Add fallback here
    if (compressedFile.size > 5 * 1024 * 1024) {
      console.warn('⚠️ Compressed file still too large, fallback to original.');
      return file;
    }

    return compressedFile;
  } catch (error) {
    console.error('❌ Image compression failed:', error);
    return file; // fallback to original file
  }
};
